import { Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';

@Component({
  selector: 'app-actions',
  imports: [ButtonModule, PopoverModule],
  templateUrl: './actions.component.html',
  styleUrl: './actions.component.scss',
})
export class ActionsComponent {
  @Input() options: {
    icon?: string;
    label?: string;
    action?: () => void;
    testId?: string;
    disabled?: boolean;
    hidden?: boolean;
  }[] = [];
}
